import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_2z2c37uymf: FaireBrandEntity = {
  token: "b_2z2c37uymf",
  type: "brand",
  name: "Sock Candy",
  avatarUrl:
    "https://cdn.faire.com/fastly/36e58f3a8833ae8f7da8c7ce34fdc55a7e3622a50875a5930b7d208296ddbd7b.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/0d11088b80f79e9e1e37da9fc90e38f0d8c097b840def25b36264c9a4efc774e.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/36e58f3a8833ae8f7da8c7ce34fdc55a7e3622a50875a5930b7d208296ddbd7b.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/0d11088b80f79e9e1e37da9fc90e38f0d8c097b840def25b36264c9a4efc774e.jpeg",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 300,
  rating: 5,
  reviewCount: 46,
  isTopShop: true,
  isInsider: true,
  description:
    "Sock Candy is a fashion-sock line that celebrates colorfully unconventional personal style. Inspired by whimsical prints, bold colors, and quirky combinations, the socks are funky yet elegant and meant to be the eye candy, adding the perfect splash of style to any outfit. The one-of-a-kind prints, high quality mercerized and combed cotton, and variety of styles make Sock Candy the one-stop destination for fashion-forward women who want to stand out from head to toe. ",
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:54:48.633Z",
    importedBy: "entity-db-cli",
  },
};
